<template lang="pug">
.carrierBelong
  alert
  .title 會員載具歸戶
  hr.w-100
  p 什麼是 <router-link :to="'/serviceContent/einvoice'">會員載具歸戶</router-link> ？
  p 將「永豐雲端印刷網會員載具」進行歸戶，日後即可使用自然人憑證或手機條碼於「<a href='https://www.einvoice.nat.gov.tw/' target='_blank' class='linkstyle-7'>財政部電子發票整合服務平台</a>」查詢電子發票資訊。平台會主動進行發票對獎、領獎等相關通知及作業。
  .searchBarContent.mb-5
    button.btn.btn-outline-secondary.btn-sm.rounded-0.font-weight-bold.searchBtn(@click="aggrCarrier") 進行歸戶
  div.d-flex.align-items-center 歸戶前須確認您已申請共通性載具：自然人憑證或手機條碼
  div.d-flex.align-items-center.mb-3
    .col
      form(id="form1" method="POST")
        input(type="hidden" id="uname" name="uname" v-model="carrierInfo.uname").form-control.rounded-0
        input(type="hidden" id="card_ban" name="card_ban" v-model="carrierInfo.card_ban").form-control.rounded-0
        input(type="hidden" id="card_no1" name="card_no1" v-model="carrierInfo.card_no1").form-control.rounded-0
        input(type="hidden" id="card_no2" name="card_no2" v-model="carrierInfo.card_no2").form-control.rounded-0
        input(type="hidden" id="card_type" name="card_type" v-model="carrierInfo.card_type").form-control.rounded-0
        input(type="hidden" id="back_url" name="back_url" v-model="carrierInfo.back_url").form-control.rounded-0
        input(type="hidden" id="token" name="token" v-model="carrierInfo.token").form-control.rounded-0
</template>

<script>
import {mapActions, mapState} from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import alert from '../components/alert'
const { mapFields } = createHelpers({
  getterType: 'carrierBelongModules/getField',
  mutationType: 'carrierBelongModules/updateField'
})
export default{
  components: {alert},
  computed: {
    ...mapFields(['carrierInfo', 'startDate', 'endDate']),
    ...mapState('carrierBelongModules', ['invoiceAry'])
  },
  methods: {
    ...mapActions('carrierBelongModules', ['aggrCarrier', 'init'])
  },
  created () {
    let vm = this
    vm.init()
  }
}
</script>

<style lang="scss" scoped>
  .title{
    font-size: 24px;
    font-weight: bold;
    font-family: 'Microsoft JhengHei',"Noto Serif TC",serif;
  }
  .searchBtn{
    flex-shrink: 0;
  }

  @media(min-width: 640px) {
    .searchBarContent{
      display:flex;
      justify-content:center;
      align-items:center;
      input[type="date"]{
        margin:0 8px;
      }
    }
  }
  @media(max-width: 641px) {
    .searchBarContent{
      display:flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      input[type="date"]{
        margin:0 0 8px;
      }
    }
  }

  th,td{
    vertical-align: middle;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/carrierBelong.vue